import { render, staticRenderFns } from "./RefinementTournament.vue?vue&type=template&id=8c6374fc&scoped=true"
import script from "./RefinementTournament.vue?vue&type=script&lang=js"
export * from "./RefinementTournament.vue?vue&type=script&lang=js"
import style0 from "./RefinementTournament.vue?vue&type=style&index=0&id=8c6374fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6374fc",
  null
  
)

export default component.exports